module.exports = __webpack_public_path__ + "static/img/dashboard-new-members.5ee3a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/dashboard-new-members.png
// module id = 9G5R
// module chunks = 0